import { CaseStatus } from './status.js';
export { CaseStatus };
export const convertUserToContact = (user) => {
    const names = user?.details?.name?.split(' ');
    return user
        ? {
            ...user?.details,
            ...user,
            lang: user?.lang || user?.details.lang,
            isAlternativeContact: user.relation === 'alternative-contact',
            firstName: names && names.length > 0 ? names[0] : null,
        }
        : null;
};
export var SystemEndReason;
(function (SystemEndReason) {
    SystemEndReason["ErrorUs"] = "ERROR_US";
    SystemEndReason["Withdrawn"] = "WITHDRAWN";
    SystemEndReason["ErrorCreditor"] = "ERROR_CREDITOR";
    SystemEndReason["Dead"] = "DEAD";
    SystemEndReason["Bankruptcy"] = "BANKRUPTCY";
    SystemEndReason["Objection"] = "OBJECTION";
    SystemEndReason["Paid"] = "PAID";
    SystemEndReason["PartiallyPaid"] = "PARTIALLY_PAID";
    SystemEndReason["Overpayment"] = "OVERPAYMENT";
    SystemEndReason["Expiration"] = "EXPIRATION";
    SystemEndReason["Irrecoverable"] = "IRRECOVERABLE";
    SystemEndReason["Transferred"] = "TRANSFERRED";
    SystemEndReason["NoCourt"] = "NO_COURT";
    SystemEndReason["Unidentified"] = "UNIDENTIFIED";
    SystemEndReason["OfferFromUs"] = "OFFER_FROM_US";
    SystemEndReason["OfferFromDebtor"] = "OFFER_FROM_DEBTOR";
    SystemEndReason["ForcedDissolved"] = "FORCED_DISSOLVED";
    SystemEndReason["NegativePayoff"] = "NEGATIVE_PAYOFF";
    SystemEndReason["Departed"] = "DEPARTED";
    SystemEndReason["CreditorUnresponsive"] = "CREDITOR_UNRESPONSIVE";
    SystemEndReason["Merged"] = "MERGED";
    SystemEndReason["FireAndForget"] = "FIRE_AND_FORGET";
    SystemEndReason["SmallCaseNotWanted"] = "SMALL_CASE_NOT_WANTED";
    SystemEndReason["AddressUnknown"] = "ADDRESS_UNKNOWN";
    SystemEndReason["DebtRelief"] = "DEBT_RELIEF";
    SystemEndReason["ConflictOfInterest"] = "CONFLICT_OF_INTEREST";
    SystemEndReason["Minor"] = "MINOR";
    SystemEndReason["Deleted"] = "DELETED";
    SystemEndReason["NoDebt"] = "NO_DEBT";
    SystemEndReason["Other"] = "OTHER";
})(SystemEndReason || (SystemEndReason = {}));
export const EndReasonId = {
    [SystemEndReason.ErrorUs]: '897298f4-d33b-4b4e-9a11-7bfb37b0bbc0',
    [SystemEndReason.Withdrawn]: '68f67f8d-200c-4c46-9310-5c3c80985510',
    [SystemEndReason.ErrorCreditor]: '85b61fc7-17e6-4669-ae5a-4ac84fae4894',
    [SystemEndReason.Dead]: '50929651-c0a6-463b-a10c-74285d2fc5eb',
    [SystemEndReason.Bankruptcy]: '31218ffa-30aa-4d8a-9978-03e33d0cb27a',
    [SystemEndReason.Objection]: 'a4636bbb-89fe-4aa5-89a7-5d1568e44ab0',
    [SystemEndReason.Paid]: 'b62f5ef1-24d3-4bc5-8aab-092b1dc24563',
    [SystemEndReason.PartiallyPaid]: '9d81fe9b-1c5c-415b-9178-13305667d207',
    [SystemEndReason.Overpayment]: 'fe88054b-81d6-46d1-932f-5d9c833a1e67',
    [SystemEndReason.Expiration]: 'b6eb1c3e-47bb-4c1c-94e6-0671a83157ad',
    [SystemEndReason.Irrecoverable]: '9a19e881-4a8a-4bcc-8c24-c01b8a925e14',
    [SystemEndReason.Transferred]: 'd7c078f7-0a07-4756-a84d-15d69e0ab53a',
    [SystemEndReason.NoCourt]: '00baf35e-e1f7-4398-91af-10e3b7efea4a',
    [SystemEndReason.Unidentified]: '80c85a59-3c40-4c4a-b00c-b704e423b9f7',
    [SystemEndReason.OfferFromUs]: '8372e6b5-f6c3-4f3a-adc1-6d6a83dd5c60',
    [SystemEndReason.OfferFromDebtor]: 'bdbe8fdb-8b56-48fb-a921-997371748cf8',
    [SystemEndReason.ForcedDissolved]: '899e2941-0ee6-4532-815b-d6a1d3c52ab6',
    [SystemEndReason.NegativePayoff]: '1505e207-f827-4715-a7f7-f77f43f081bf',
    [SystemEndReason.Departed]: '474eef72-6231-4db5-a3bd-d57eabfa2e13',
    [SystemEndReason.CreditorUnresponsive]: '082b2e7b-74bd-4d3b-9d1d-de8506d859f8',
    [SystemEndReason.Merged]: 'dc37b11f-0911-4850-8e5b-442eef720783',
    [SystemEndReason.FireAndForget]: 'ea60e5ee-a896-4631-8914-1ee9b94f8020',
    [SystemEndReason.SmallCaseNotWanted]: '884a1eb3-9fcd-45cd-8395-aa6bec850df8',
    [SystemEndReason.AddressUnknown]: '8c2e0fee-6c3e-4a0d-aff6-6a88d68ad841',
    [SystemEndReason.DebtRelief]: '38fa5c2d-d2f4-4a84-b169-ae64dbc55df2',
    [SystemEndReason.ConflictOfInterest]: '9bc7fcaa-c304-4db8-b267-52ce85ce0ba4',
    [SystemEndReason.Minor]: '8ca51236-c3f9-418c-bdbe-42a102020ace',
    [SystemEndReason.Deleted]: '723aafa4-daa3-46c6-a7a0-8d2108624d46',
    [SystemEndReason.NoDebt]: '72baa261-f455-4f47-b655-8c421d090643',
    [SystemEndReason.Other]: '43864492-062b-4457-bd1f-443ec7214555',
};
export const EndReasonHandle = Object.fromEntries(Object.entries(EndReasonId).map(([key, val]) => [val, key]));
export var CaseState;
(function (CaseState) {
    CaseState["ALL"] = "ALL";
    CaseState["ACTIVE"] = "ACTIVE";
    CaseState["CLOSED"] = "CLOSED";
})(CaseState || (CaseState = {}));
export var CaseType;
(function (CaseType) {
    CaseType["TENANT"] = "TENANT";
    CaseType["CLIENT"] = "CLIENT";
})(CaseType || (CaseType = {}));
export var CaseTag;
(function (CaseTag) {
    CaseTag["SURVEILLANCE"] = "SURVEILLANCE";
})(CaseTag || (CaseTag = {}));
export var CaseJournalNumberFormat;
(function (CaseJournalNumberFormat) {
    CaseJournalNumberFormat["CustomString"] = "CUSTOM_STRING";
})(CaseJournalNumberFormat || (CaseJournalNumberFormat = {}));
export const getJournalNumber = (customJournalNumber, caseSequentialId, userOnCustomerSequentialId) => {
    if (customJournalNumber?.type === CaseJournalNumberFormat.CustomString) {
        return customJournalNumber.journalNumber;
    }
    return `${caseSequentialId}${userOnCustomerSequentialId != null ? `-${userOnCustomerSequentialId}` : ''}`;
};
export const getCollectorOnCase = (caseType, caseCollectorId, creditorIdentityCollectorId, creditorDefaultCollectorId) => {
    const creditorCollector = caseType === CaseType.TENANT
        ? creditorDefaultCollectorId
        : creditorIdentityCollectorId;
    return caseCollectorId || creditorCollector;
};
export const validStatusMove = (fromStatus, toStatus) => {
    switch (fromStatus) {
        case CaseStatus.PENDING:
            return [
                CaseStatus.ENDED,
                CaseStatus.VERIFIED,
                CaseStatus.PENDING, // TODO: When creating a new case it is already pending
            ].includes(toStatus);
        case CaseStatus.VERIFIED:
            return [CaseStatus.ENDED].includes(toStatus);
        case CaseStatus.ENDED:
            return [CaseStatus.VERIFIED, CaseStatus.ENDED].includes(toStatus);
        default:
            return false;
    }
};
//# sourceMappingURL=index.js.map